import React from 'react';

import { isMobileMedia } from 'utils/media';
import MenuItemDetailRoute from 'menus/containers/MenuItemDetailRoute';
import MenuContainer from 'menus/containers/MenuContainer';
import withGoogleLibraryLoaded from 'base/hoc/withGoogleLibraryLoaded';

/* ONLY WHEN YOU HIT ROUTE DIRECTLY, NOT NAVIGATING TO IT */
const MenuItemDetailContainer = () => {
  if (isMobileMedia()) {
    return <MenuItemDetailRoute />;
  }
  return <MenuContainer shouldOpenMenuItemDetailModal />;
};

export default withGoogleLibraryLoaded(MenuItemDetailContainer);
